import type { UUID } from '@/types/common'
import type { CreateDriverRequest, Driver, DriverExpensesResponse, DriversResponse, UpdateDriverRequest } from '@/types/driver'
import type { ModifySettlementPaymentRequest, Settlement, SettlementsResponse, UpdateDriverBalanceRequest } from '@/types/settlement'

import { api } from './client'

export interface GetDriversParams {
  name?: string;
  phone?: string;
  createdAfter?: string;
  createdBefore?: string;
  page?: number;
  limit?: number;
  sort?: string[];
}

export interface GetDriversSettlementsParams {
  driverID?: UUID;
  page?: number;
  limit?: number;
  sort?: string[];
}

export interface GetDriverExpensesParams {
  date?: string;
  page?: number;
  limit?: number;
  sort?: string[];
}

export interface GetDriverSettlementParams {
  date?: string;
}

export const driversApi = {
  getDrivers: (params?: GetDriversParams) =>
    api.get<DriversResponse>('/drivers', params),

  createDriver: (data: CreateDriverRequest) =>
    api.post<Driver>('/drivers', data),

  getDriver: (id: UUID) =>
    api.get<Driver>(`/drivers/${id}`),

  updateDriver: (id: UUID, data: UpdateDriverRequest) =>
    api.put<Driver>(`/drivers/${id}`, data),

  deleteDriver: (id: UUID) =>
    api.delete<void>(`/drivers/${id}`),

  getDriverExpenses: (id: UUID, params?: GetDriverExpensesParams) =>
    api.get<DriverExpensesResponse>(`/drivers/${id}/expenses`, params),

  getDriversSettlements: (params?: GetDriversSettlementsParams) =>
    api.get<SettlementsResponse>('/drivers/settlements', params),

  getDriverSettlement: (id: UUID, params?: GetDriverSettlementParams) =>
    api.get<Settlement>(`/drivers/${id}/settlement`, params),

  updateDriverBalance: (id: UUID, data: UpdateDriverBalanceRequest) =>
    api.put<Settlement>(`/drivers/${id}/balance`, data),

  createDriverPayment: (id: UUID, data: ModifySettlementPaymentRequest) =>
    api.post<Settlement>(`/drivers/${id}/settlement`, data),

  updateDriverPayment: (id: UUID, paymentId: UUID, data: ModifySettlementPaymentRequest) =>
    api.put<Settlement>(`/drivers/${id}/settlement/${paymentId}`, data),

  deleteDriverPayment: (id: UUID, paymentId: UUID) =>
    api.delete<void>(`/drivers/${id}/settlement/${paymentId}`),
}
